import "./footer.css";

const mailTo =
  "mailto:airton_mio@hotmail.com?subject=Contato%20via%20Portf%C3%B3lio&body=Ol%C3%A1%20Airton,%20vamos%20conversar%20sobre...";

const socialLinks = [
  { label: "GitHub", url: "https://github.com/AirtonDomiciano" },
  { label: "LinkedIn", url: "https://www.linkedin.com/in/airton-domiciano-93b081213/" },
  { label: "Email", url: mailTo },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="s-footer">
      <div className="s-footer__orb" aria-hidden="true" />
      <div className="s-footer__ring" aria-hidden="true" />

      <div className="s-footer__container">
        <div className="s-footer__brand" data-aos="fade-up" data-aos-delay="60">
          <div className="s-footer__logo">AD</div>
          <p className="s-footer__mission">
            Construindo experiências digitais que equilibram performance, estética e resultados.
          </p>
        </div>

        <nav className="s-footer__nav" aria-label="Links sociais">
          {socialLinks.map((link) => {
            const isMail = link.url.startsWith("mailto:");
            return (
              <a
                key={link.label}  
                href={link.url}
                target={isMail ? undefined : "_blank"}
                rel={isMail ? undefined : "noreferrer"}
                className="s-footer__nav-link"
              >
              <span>{link.label}</span>
              </a>
            );
          })}
        </nav>

        <div className="s-footer__note">
          <span className="s-footer__meteor" aria-hidden="true" />
          <p>
            {year} • Design e código por Airton Domiciano. Vamos criar algo incrível juntos.
          </p>
        </div>
      </div>
    </footer>
  );
}
